import { 
    CreateQuoteAccommodationDto, 
    DeleteQuoteAccommodationDto,
    EditQuoteAccommodationDto,
    GetQuoteAccommodationDto, 
    MessageResponseDto, 
    QuoteAccommodationApiFp,
    QuoteAccommodationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseQuoteAccommodationModel = QuoteAccommodationControllerGet200Response;
export type GetQuoteAccommodationModel = GetQuoteAccommodationDto;
export type MutateResponseQuoteAccommodationModel = MessageResponseDto;
export type CreateQuoteAccommodationModel = CreateQuoteAccommodationDto;
export type UpdateQuoteAccommodationModel = EditQuoteAccommodationDto;
export type DeleteQuoteAccommodationModel = DeleteQuoteAccommodationDto;

export const apiQuoteAccommodationFp = QuoteAccommodationApiFp(apiConfig);
export const getQuoteAccommodationController = apiQuoteAccommodationFp.quoteAccommodationControllerGet;
export const createQuoteAccommodationController = apiQuoteAccommodationFp.quoteAccommodationControllerCreate;
export const updateQuoteAccommodationController = apiQuoteAccommodationFp.quoteAccommodationControllerEdit;
export const deleteQuoteAccommodationController = apiQuoteAccommodationFp.quoteAccommodationControllerDelete;

export const QueryKeyQuoteAccommodation = QueryKey.QuoteAccommodation;